import { render, staticRenderFns } from "./PermissionGate.vue?vue&type=template&id=1e1eb3c6"
import script from "./PermissionGate.vue?vue&type=script&lang=js"
export * from "./PermissionGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports